import { css } from 'styled-components';
import typographyCss from './typography.css';

export const typographyTokens = css`
  ${typographyCss}
`;
